module.exports = __webpack_public_path__ + "img/prol_mediale_sx.320aeb18.png";